import React, { useState } from "react";
import NameEnquiry from "./NameEnquiry";
import MandateAdvice from "./MandateAdvice";
import BalanceEnquiry from "./BalanceEnquiry";
import FundTransferDirectCredit from "./FundTransferDirectCredit";
import FundTransferAdviceDirectCredit from "./FundTransferAdviceDirectCredit";
import FundTransferDirectDebit from "./FundTransferDirectDebit";
import FundTransferAdviceDirectDebit from "./FundTransferAdviceDirectDebit";
import AmountBlock from "./AmountBlock";
import AccountBlock from "./AccountBlock";
import FinancialInstitutionList from "./FinancialInstitutionList";
import {
  nameEnquiry,
  mandateAdvice,
  balanceEnquiry,
  fundTransferDirectCredit,
  fundTransferAdviceDirectCredit,
  fundTransferDirectDebit,
  fundTransferAdviceDirectDebit,
  amountBlock,
  accountBlock,
  financialInstitutionList,
} from "../../utils/Functions/ActiveInward";

const InwardInteraction = () => {
  const [state, setState] = useState({
    active1: true,
    active2: false,
    active3: false,
    active4: false,
    active5: false,
    active6: false,
    active7: false,
    active8: false,
    active9: false,
    active10: false,
  });

  return (
    <div className="nip-home-interaction">
      {state.active1 ? (
        <NameEnquiry goToMandateAdvice={() => mandateAdvice(setState, state)} />
      ) : state.active2 ? (
        <MandateAdvice
          goToBalanceEnquiry={() => balanceEnquiry(setState, state)}
          goToNameEnquiry={() => nameEnquiry(setState, state)}
        />
      ) : state.active3 ? (
        <BalanceEnquiry
          goToFundTransferDirectCredit={() =>
            fundTransferDirectCredit(setState, state)
          }
          goToMandateAdvice={() => mandateAdvice(setState, state)}
        />
      ) : state.active4 ? (
        <FundTransferDirectCredit
          goToFundTransferAdviceDirectCredit={() =>
            fundTransferAdviceDirectCredit(setState, state)
          }
          goToBalanceEnquiry={() => balanceEnquiry(setState, state)}
        />
      ) : state.active5 ? (
        <FundTransferAdviceDirectCredit
          goToFundTransferDirectDebit={() =>
            fundTransferDirectDebit(setState, state)
          }
          goToFundTransferDirectCredit={() =>
            fundTransferDirectCredit(setState, state)
          }
        />
      ) : state.active6 ? (
        <FundTransferDirectDebit
          goToFundTransferAdviceDirectDebit={() =>
            fundTransferAdviceDirectDebit(setState, state)
          }
          goToFundTransferAdviceDirectCredit={() =>
            fundTransferAdviceDirectCredit(setState, state)
          }
        />
      ) : state.active7 ? (
        <FundTransferAdviceDirectDebit
          goToAmountBlock={() => amountBlock(setState, state)}
          goToFundTransferDirectDebit={() =>
            fundTransferDirectDebit(setState, state)
          }
        />
      ) : state.active8 ? (
        <AmountBlock
          goToAccountBlock={() => accountBlock(setState, state)}
          goToFundTransferAdviceDirectDebit={() =>
            fundTransferAdviceDirectDebit(setState, state)
          }
        />
      ) : state.active9 ? (
        <AccountBlock
          goToFinancialInstitutionList={() =>
            financialInstitutionList(setState, state)
          }
          goToAmountBlock={() => amountBlock(setState, state)}
        />
      ) : (
        <FinancialInstitutionList
          goToNameEnquiry={() => nameEnquiry(setState, state)}
          goToAccountBlock={() => accountBlock(setState, state)}
        />
      )}
    </div>
  );
};

export default InwardInteraction;
